import * as React from "react";
import { Icon } from "../icon/Icon";
export var BouncingArrow = function (props) {
    var containerCSSProps = props.containerCSSProps, icon = props.icon, iconOrientation = props.iconOrientation, iconStyle = props.iconStyle;
    return (React.createElement("div", { style: containerCSSProps, className: "bouncing-arrow bouncing-arrow-bounce" },
        React.createElement(Icon, { icon: icon, styleId: iconStyle, orientation: iconOrientation })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/BouncingArrow.tsx
// module id = 480
// module chunks = 3